import { store } from '../configureStore';

export const saveItemToStore = (type, value) => {
  store.dispatch({ type, value });
};

export const getItemFromStore = (keyname) => {
  let retValue = '';
  const reducer = store.getState()?.SessionValues ? store.getState()?.SessionValues : null;
  if (reducer !== undefined && reducer !== null) {
    retValue = (reducer[keyname] !== undefined && reducer[keyname] !== null) ? reducer[keyname] : '';
  }
  return retValue;
};
